(function () {
  const bar = document.getElementById('sticky-atc-bar');
  if (!bar) return;

  var form = null;
  var productInfo = null;
  if (bar.dataset.findMain === 'true') {
    productInfo = document.querySelector('product-info[id^="MainProduct"]');
    if (productInfo) form = productInfo.querySelector('form[id^="product-form-"]');
  } else {
    const formId = bar.dataset.productFormId;
    const productInfoId = bar.dataset.productInfoId;
    if (!formId || !productInfoId) return;
    form = document.getElementById(formId);
    productInfo = document.getElementById(productInfoId);
  }
  if (!form || !productInfo) return;

  const hasSubscriptions = bar.dataset.hasSubscriptions === 'true';

  const titleEl = bar.querySelector('.sticky-atc__title');
  const buttonEl = bar.querySelector('.sticky-atc__button');
  const priceSpan = bar.querySelector('.sticky-atc__button .add-to-cart-price');

  if (!form || !productInfo || !buttonEl || !priceSpan) return;

  const mainSubmitBtn = form.querySelector('.product-form__submit');

  var chooseOptionsText = 'Choose Options';

  function syncFromMain() {
    var mainPriceSpan = mainSubmitBtn && mainSubmitBtn.querySelector('.add-to-cart-price');
    var mainTitleEl = productInfo.querySelector('.product__title h2') || productInfo.querySelector('.product__title') || productInfo.querySelector('.block__main-product-title');

    if (mainTitleEl && titleEl) {
      titleEl.textContent = mainTitleEl.textContent.trim();
    }
    if (hasSubscriptions && isSubscriptionSelected()) {
      priceSpan.textContent = chooseOptionsText;
      buttonEl.setAttribute('aria-label', chooseOptionsText);
    } else if (mainPriceSpan && priceSpan) {
      priceSpan.textContent = mainPriceSpan.textContent.trim();
      buttonEl.setAttribute('aria-label', priceSpan.textContent.trim() || 'Add to cart');
    }
    var disabled = mainSubmitBtn && (mainSubmitBtn.hasAttribute('disabled') || mainSubmitBtn.getAttribute('aria-disabled') === 'true');
    if (disabled) {
      buttonEl.setAttribute('disabled', '');
      buttonEl.setAttribute('aria-disabled', 'true');
    } else {
      buttonEl.removeAttribute('disabled');
      buttonEl.removeAttribute('aria-disabled');
    }
  }

  function isSubscriptionSelected() {
    if (!hasSubscriptions) return false;
    const subscribeRadio = productInfo.querySelector('.block_subscription-options input[type=radio][value="subscribe"]');
    return subscribeRadio && subscribeRadio.checked;
  }

  function setBarVisible(visible) {
    if (visible) {
      bar.removeAttribute('hidden');
      document.body.classList.add('sticky-atc-visible');
    } else {
      bar.setAttribute('hidden', '');
      document.body.classList.remove('sticky-atc-visible');
    }
  }

  var mainAtcWasInView = null;

  function isMainAtcAboveViewport(rect) {
    if (!rect) return false;
    return rect.bottom < 0;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var nowInView = entry.isIntersecting;
        var rect = entry.boundingClientRect;

        if (mainAtcWasInView === null) {
          mainAtcWasInView = nowInView;
          if (!nowInView && isMainAtcAboveViewport(rect)) {
            setBarVisible(true);
          }
          return;
        }
        if (mainAtcWasInView && !nowInView) {
          if (isMainAtcAboveViewport(rect)) {
            setBarVisible(true);
          }
        } else if (nowInView) {
          setBarVisible(false);
        }
        mainAtcWasInView = nowInView;
      });
    },
    { root: null, rootMargin: '0px', threshold: 0 }
  );

  if (mainSubmitBtn) {
    observer.observe(mainSubmitBtn);
    if (document.readyState === 'complete') {
      checkInitialScrollPosition();
    } else {
      window.addEventListener('load', checkInitialScrollPosition);
    }
  }

  function checkInitialScrollPosition() {
    if (!mainSubmitBtn) return;
    var rect = mainSubmitBtn.getBoundingClientRect();
    if (!bar.hasAttribute('hidden')) return;
    if (isMainAtcAboveViewport(rect)) {
      setBarVisible(true);
    }
  }

  buttonEl.addEventListener('click', function () {
    if (buttonEl.hasAttribute('disabled') || buttonEl.getAttribute('aria-disabled') === 'true') return;

    if (hasSubscriptions && isSubscriptionSelected()) {
      productInfo.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (!mainSubmitBtn) return;
    if (mainSubmitBtn.hasAttribute('disabled') || mainSubmitBtn.getAttribute('aria-disabled') === 'true') return;

    buttonEl.setAttribute('disabled', '');
    buttonEl.setAttribute('aria-disabled', 'true');
    mainSubmitBtn.click();
    function reEnable() {
      buttonEl.removeAttribute('disabled');
      buttonEl.removeAttribute('aria-disabled');
      syncFromMain();
      setTimeout(syncFromMain, 150);
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      var unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        reEnable();
        if (unsubCart) unsubCart();
      });
    }
    setTimeout(reEnable, 3000);
  });

  syncFromMain();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(syncFromMain, 0);
    });
  }

  var subscriptionRadios = productInfo.querySelectorAll('.shopify_subscriptions_app_block_label input[type=radio]');
  if (subscriptionRadios.length) {
    subscriptionRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        setTimeout(syncFromMain, 0);
      });
    });
  }

  var priceObserver = new MutationObserver(function () {
    syncFromMain();
  });
  if (mainSubmitBtn) {
    priceObserver.observe(mainSubmitBtn, { characterData: true, childList: true, subtree: true });
  }

})();
